import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Instagram, Music2, Youtube, Twitter, Facebook } from "lucide-react";
import { api } from "@/lib/api";

const INFLUCAST_URL = "https://www.influcastbo.com";

const ICONS = {
  instagram: { Icon: Instagram, label: "Instagram" },
  tiktok: { Icon: Music2, label: "TikTok" },
  youtube: { Icon: Youtube, label: "YouTube" },
  twitter: { Icon: Twitter, label: "X (Twitter)" },
  facebook: { Icon: Facebook, label: "Facebook" },
};

export default function Footer() {
  const [social, setSocial] = useState({});

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setSocial(r.data?.social_links || {}))
      .catch(() => {});
  }, []);

  const visibleSocial = Object.entries(ICONS).filter(([k]) => (social[k] || "").trim() !== "");

  return (
    <footer
      className="mt-20 pt-10 pb-6 px-4 md:px-8"
      style={{ background: "var(--footer-bg)", color: "#fafafa" }}
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto flex flex-col md:flex-row items-center md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <Link to="/" data-testid="footer-logo">
            <span className="popu-logo text-xl text-white">
              POPU<span className="dot-news accent-text">.news</span>
            </span>
          </Link>
          <a
            href={INFLUCAST_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-influcast-link"
            className="text-xs uppercase tracking-widest text-white/60 hover:text-white transition border-l border-white/20 pl-3 ml-1"
          >
            by <span className="accent-text">✦ INFLUCAST</span>
          </a>
        </div>

        {visibleSocial.length > 0 && (
          <div className="flex items-center gap-5">
            {visibleSocial.map(([k, { Icon, label }]) => (
              <a
                key={k}
                href={social[k]}
                target="_blank"
                rel="noreferrer"
                data-testid={`footer-${k}`}
                aria-label={label}
              >
                <Icon size={18} className="text-white/80 hover:text-white transition" />
              </a>
            ))}
          </div>
        )}

        <div className="flex flex-wrap items-center gap-4 md:gap-6 text-xs uppercase tracking-widest text-white/60">
          <Link to="/contacto" className="hover:text-white transition" data-testid="footer-contact-link">Contacto</Link>
          <Link to="/nosotros" className="hover:text-white transition">Nosotros</Link>
          <Link to="/anunciantes" className="hover:text-white transition">Anunciantes</Link>
          <Link to="/terminos" className="hover:text-white transition">Términos</Link>
          <Link to="/privacidad" className="hover:text-white transition">Privacidad</Link>
        </div>
      </div>
      <div className="max-w-[1440px] mx-auto mt-6 pt-6 border-t border-white/10 text-[10px] uppercase tracking-widest text-white/40 flex flex-wrap items-center justify-center md:justify-start gap-3">
        <span>© {new Date().getFullYear()} POPU.NEWS · Todos los derechos reservados</span>
        <span className="opacity-50">·</span>
        <Link
          to="/admin"
          className="text-white/30 hover:text-white/70 transition"
          data-testid="footer-admin-link"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
}
